module.exports = __webpack_public_path__ + "static/img/4156_phase_function_Paper_Points.f228da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4156_phase_function_Paper_Points.png
// module id = kqQs
// module chunks = 0